import React from "react";
import AmgPage from "./AmgPage";

export default function AirplaneModeGamesPrivacyPage() {
  return (
    <AmgPage title="Privacy Policy" effective="Effective September 16, 2026">
      <p>
        Airplane Mode Games, by Testcode Inc., are built for the places the
        internet can't reach — games that run entirely on the phones
        sitting around the table. That design makes this policy short:{" "}
        <strong>our games collect no personal data.</strong> This policy
        covers every game in the family, currently Airplane Mode Poker,
        Airplane Mode Liar's Dice, and Airplane Mode Classic Board Games
        (chess, checkers, and backgammon).
      </p>
      <h2>1. Data We Collect</h2>
      <p>
        None. Everything a game needs happens on the devices at your
        table, so nothing is ever sent to us or to anyone else. There are
        no accounts to create, and the apps contain no analytics,
        advertising, or crash-reporting services.
      </p>
      <h2>2. How the Games Work (Bluetooth)</h2>
      <p>
        Games are played directly between nearby devices over Bluetooth
        Low Energy. When you host or join a table, the following travels
        by local radio between the devices at your table only:
      </p>
      <ul>
        <li>The table name the host chose</li>
        <li>The display name you chose for yourself</li>
        <li>
          Game state (in poker: cards, chips, bets; in liar's dice: dice
          and bids; in the board games: the board, moves, dice, and the
          doubling cube)
        </li>
        <li>Chat messages, if you send any</li>
      </ul>
      <p>
        This information goes device-to-device and is never uploaded
        anywhere. Like most local radio traffic, Bluetooth advertisements
        and game frames are not encrypted, so they are technically visible
        to other Bluetooth radios in physical range — the apps tell you
        this where it matters, and table passwords gate who may join a
        closed table. Chat and game history for a table are held in memory
        only and disappear when the table closes.
      </p>
      <p>
        Pass &amp; play in Airplane Mode Classic Board Games is two players
        sharing one device, and nothing about the game leaves that device.
      </p>
      <h2>3. Data Stored on Your Device</h2>
      <p>
        Your settings (such as your display name, the optional open-table
        alert toggle, or the board games' table color) are stored locally
        on your device and never leave it, as is Airplane Mode Classic Board
        Games' count of free hosted games played. Deleting an app deletes
        them.
      </p>
      <h2>4. Purchases</h2>
      <p>
        Our games are free to download and free for joining tables.
        Hosting tables is unlocked with a single one-time purchase (in
        Airplane Mode Classic Board Games, each device hosts its first game
        free, and pass &amp; play is always free),
        processed entirely by Apple's App Store or Google Play: they
        handle the payment under their own privacy policies, we never see
        your payment details, and the app sends nothing about the purchase
        (or anything else) to us. Your unlock is remembered on your
        device, so what it unlocks keeps working with no connection at all —
        buying does require a connection, so it's worth doing before you
        board. On a new device, use Restore Purchases in the app with the
        same store account.
      </p>
      <h2>5. Permissions</h2>
      <ul>
        <li>
          <strong>Bluetooth</strong> — used solely to discover, host, and
          join nearby tables. On Android 12+ we declare the scan as
          "neverForLocation": we derive no location from Bluetooth. On
          Android 11 and below the operating system required the location
          permission to allow Bluetooth scanning at all; the apps still
          collect no location.
        </li>
        <li>
          <strong>Notifications</strong> (optional, Android) — if you turn
          on "Open tables nearby," the app shows a notification generated
          entirely on your device when a nearby open table is spotted. This
          is off by default.
        </li>
      </ul>
      <h2>6. Children</h2>
      <p>
        Our games involve no real-money wagering — the chips in Airplane
        Mode Poker are play money, and chips can never be bought, won as
        money, or cashed out; Airplane Mode Liar's Dice and Airplane Mode
        Classic Board Games have no chips or currency at all (backgammon's
        doubling cube only multiplies the points one game is worth). The
        only purchase in each game is the one-time unlock described above,
        handled by the App Store or Google Play under their rules. Because
        we collect no personal data from anyone, we also collect none from
        children.
      </p>
      <h2>7. Your Rights (GDPR, CCPA, and Similar Laws)</h2>
      <p>
        Privacy laws give you rights over personal data that companies
        hold about you. We hold none: there is nothing for us to access,
        correct, delete, port, or sell. If you have any question about
        this, contact us and we will happily confirm it in writing.
      </p>
      <h2>8. Changes to This Policy</h2>
      <p>
        If a game ever changes in a way that affects this policy, we will
        update this page and the effective date above before the change
        ships. New games in the family will be added here by name.
      </p>
      <h2>9. Contact</h2>
      <ul>
        <li>help@testco.de</li>
        <li>https://testco.de/airplane-mode-games</li>
      </ul>
    </AmgPage>
  );
}
